"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var styles = {
  popper: {
    zIndex: 'modal'
  },
  paper: {
    position: 'relative',
    boxShadow: "0 1px 5px 0px rgb(0 0 0 / 20%)"
  },
  paperArrow: {
    overflow: 'hidden',
    position: 'absolute',
    width: '1.5em',
    height: '1em',
    boxSizing: 'border-box',
    color: 'common.white',
    right: 21,
    bottom: '-1em',
    '&:before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundColor: 'currentColor',
      transform: 'rotate(45deg)',
      boxShadow: "0 1px 5px 0px rgb(0 0 0 / 20%)",
      transformOrigin: '100% 0'
    }
  }
};
var StyledPopper = (0, _material.styled)(_material.Popper)({});

var ScheduleModal = function ScheduleModal(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children,
      anchorEl = _ref.anchorEl;
  return /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
    onClickAway: onClose
  }, /*#__PURE__*/_react.default.createElement(StyledPopper, {
    sx: styles.popper,
    open: open,
    anchorEl: anchorEl,
    placement: "top-end",
    modifiers: [{
      name: 'flip',
      enabled: true
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altBoundary: true
      }
    }],
    role: undefined,
    transition: true,
    disablePortal: true
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/_react.default.createElement(_material.Zoom, (0, _extends2.default)({}, TransitionProps, {
      style: {
        transformOrigin: 'right bottom'
      },
      mountOnEnter: true,
      unmountOnExit: true
    }), /*#__PURE__*/_react.default.createElement(_material.Paper, {
      sx: styles.paper
    }, children, /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.paperArrow
    })));
  }));
};

var _default = ScheduleModal;
exports.default = _default;